export const RENDERERS = [
  {key: "mjml", name: "Notion Page", description: ["Emails looks like Notion pages. This is main rendering engine."]},
  {key: "md", name: "Plain Text", description: ["Text emails with basic markdown formatting. Work only with private pages."]}
]

export const DEFAULT_RENDERER = "mjml"

export const MJML_ENGINE = "mjml"
export const MD_ENGINE = "md"